module.exports = __webpack_public_path__ + "img/mindful_days_30.791629e3.svg";